import AscendingLogoGrey from "assets/img/illustrations/AscendingLogoGrey";
import DescendingLogoGrey from "assets/img/illustrations/DescendingLogoGrey";
import NoData from "assets/svgs/no_data/NoData";
import PaginationDiv from "modules/pagination/PaginationDiv";
import { fourPlaceHolder } from "modules/utilities/utility";
import React, { useEffect, useState } from "react";

function PerformanceTable({
  performanceData,
  performanceLoading,
  allUser,
  agent,
}) {
  const [sortedData, setSortedData] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [page, newPage] = useState(1);
  const [orgSortedData, setOrgSortedData] = useState([]);
  const [opa, setOpa] = useState(null);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (performanceData) {
      const userData = performanceData ? Object.keys(performanceData) : [];
      setSortedData(userData);
      setOrgSortedData(userData);
    }
  }, [performanceData]);

  useEffect(() => {
    if (agent) {
      setSortedData([
        ...orgSortedData?.filter((item) => {
          if (allUser[item]) {
            return allUser[item].includes(agent);
          }
        }),
      ]);
    } else {
      setSortedData(orgSortedData);
    }
  }, [agent]);

  useEffect(() => {
    const numOfSubarrays = Math.max(
      Math.ceil((sortedData?.length || 0) / 10),
      0
    );
    const arrayOfArrays = sortedData
      ? Array.from({ length: numOfSubarrays }, (_, i) => {
          const start = i * 10;
          const end = start + 10;
          return sortedData?.slice(start, end);
        })
      : [];
    setFilterData(arrayOfArrays[page - 1]);
  }, [sortedData, page]);

  const handleTalkSort = () => {
    if (sortedData?.length === 0) {
      return;
    }

    if (count === 0) {
      setOpa("dsc");
      setCount(1);
      setSortedData([
        ...orgSortedData?.sort(
          (a, b) =>
            Number(performanceData[a]?.attempt_duration) -
            Number(performanceData[b]?.attempt_duration)
        ),
      ]);
    } else if (count === 1) {
      setOpa("asc");
      setCount(2);
      setSortedData([
        ...orgSortedData?.sort(
          (a, b) =>
            Number(performanceData[b]?.attempt_duration) -
            Number(performanceData[a]?.attempt_duration)
        ),
      ]);
    } else if (count === 2) {
      setOpa("");
      setCount(0);
      setSortedData([...orgSortedData]);
    }
  };

  const header = [
    "Agent Name",
    "Total Attempted Calls",
    "Total Answered Calls",
    "Total Unanswered Calls",
  ];

  return (
    <div>
      <div>
        <div
          className="mt-1 shadow rounded mt-3 scrollable-container"
          style={{ maxHeight: "70vh", overflowY: "scroll" }}
        >
          <div
            className="d-flex table-head rounded-top"
            style={{ position: "sticky", top: "0" }}
          >
            {header?.map((item) => {
              return (
                <span className="p-3 py-4 fw-bold text-black flex-1 border-end">
                  {item}
                </span>
              );
            })}
            <span
              className="p-3 py-4 fw-bold text-black flex-1 border-end cursor-pointer"
              onClick={handleTalkSort}
            >
              Total Talk Time (Minute)
              <div
                style={{
                  display: "inline-block",
                  verticalAlign: "middle",
                  paddingLeft: "1rem",
                }}
              >
                <div
                  className={
                    opa === ""
                      ? "opacity-100"
                      : opa === "asc"
                      ? "opacity-50"
                      : "opacity-100"
                  }
                >
                  <AscendingLogoGrey />
                </div>
                <div
                  className={
                    opa === ""
                      ? "opacity-100 mt-n2"
                      : opa === "dsc"
                      ? "opacity-50 mt-n2"
                      : "opacity-100 mt-n2"
                  }
                >
                  <DescendingLogoGrey />
                </div>
              </div>
            </span>
            <span className="p-3 py-4 fw-bold text-black flex-1 border-end">
              Average Talk Time (Minute)
            </span>
          </div>
          {performanceLoading ? (
            fourPlaceHolder()
          ) : filterData && filterData?.length ? (
            filterData?.map((item, index) => {
              const userPerformance = performanceData[item];
              return (
                <div
                  className={`d-flex table-row border-1 border-top-0 ${
                    index === filterData?.length - 1 && `rounded-bottom`
                  }`}
                >
                  <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                    {allUser[item]}
                  </span>
                  <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                    {userPerformance?.total_attempted_call}
                  </span>
                  <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                    {userPerformance?.total_answered_call}
                  </span>
                  <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                    {userPerformance?.total_unanswered_call}
                  </span>
                  <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                    {(
                      Number(userPerformance?.attempt_duration) / 60000 || 0
                    ).toFixed(2)}
                  </span>
                  <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                    {(
                      Number(userPerformance?.attempt_duration) /
                      (Number(userPerformance?.total_answered_call) || 1) /
                      60000
                    ).toFixed(2)}
                  </span>
                </div>
              );
            })
          ) : (
            <div className="p-3 bg-white rounded-bottom text-center">
              No Data Available <NoData />
            </div>
          )}
        </div>
        <PaginationDiv
          paginationData={{
            pageCount: sortedData?.length
              ? Math.ceil(sortedData?.length / 10)
              : 1,
            page: page,
          }}
          newPage={newPage}
        />
      </div>
    </div>
  );
}

export default PerformanceTable;
